import { useState, useEffect } from 'react';

interface SettingsData {
  // Các thuộc tính mặc định cho settings
  aiModel?: string;
  aiTemperature?: number;
  maxTokens?: number;
  defaultLanguage?: string;
  theme?: 'light' | 'dark' | 'system';
}

export function useSettings() {
  const [settings, setSettings] = useState<SettingsData>({
    aiModel: 'anthropic/claude-3-haiku',
    aiTemperature: 0.7,
    maxTokens: 1000,
    defaultLanguage: 'vi',
    theme: 'system'
  });
  
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Load settings from localStorage on component mount
  useEffect(() => {
    try {
      const savedSettings = localStorage.getItem('user-settings');
      if (savedSettings) {
        setSettings(JSON.parse(savedSettings));
      }
    } catch (err) {
      console.error('Error loading settings:', err);
    }
  }, []);

  // Function to update settings
  const updateSettings = (newSettings: Partial<SettingsData>) => {
    setSettings(prev => {
      const updated = { ...prev, ...newSettings };
      // Save to localStorage
      localStorage.setItem('user-settings', JSON.stringify(updated));
      return updated;
    });
  };

  return {
    settings,
    updateSettings,
    isLoading,
    error
  };
}

export default useSettings; 